import React, { useMemo } from 'react';
import IncidentCard from './IncidentCard';
import type { Incident } from '../types';
import { useTranslation } from 'react-i18next';

interface IncidentListProps {
  incidents: Incident[];
}

export default function IncidentList({ incidents }: IncidentListProps) {
  const { t } = useTranslation();
  
  const sortedIncidents = useMemo(() => {
    return [...incidents].sort((a, b) => {
      // Sort by severity first
      const severityOrder = { CRITICAL: 0, HIGH: 1, MODERATE: 2, LOW: 3 };
      const severityDiff = severityOrder[a.severity as keyof typeof severityOrder] - 
                          severityOrder[b.severity as keyof typeof severityOrder];
      
      if (severityDiff !== 0) return severityDiff;
      
      // Then by date (newest first)
      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    });
  }, [incidents]);

  if (incidents.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">{t('incident.empty.message')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {sortedIncidents.map((incident) => (
        <div key={incident.id} className="mx-auto max-w-sm">
          <IncidentCard incident={incident} />
        </div>
      ))}
    </div>
  );
}